export default __webpack_public_path__ + "static/media/DG.d5b11b07.svg";